{
  "name": "lyric-stream.frontend.public",
  "version": "1.0.14",
  "scripts": {
    "ng": "ng",
    "start": "npm cache clean -f && npm run build:shared && ng serve",
    "start:dev": "npm cache clean -f && npm run build:shared && ng serve --configuration development",
    "build:shared": "cd ../LyricStream.Frontend.Shared && npm run build:prod",
    "start:qa": "npm cache clean -f && npm run build:shared && ng serve --configuration qa",
    "start:prod": "npm cache clean -f && npm run build:shared && ng serve --configuration production",
    "lint": "echo 'Linting not configured yet'",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:qa": "ng build --configuration qa",
    "build:prod": "ng build --configuration production",
    "watch": "npm cache clean -f && npm run build:shared && ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:LyricStream.Frontend.Public": "node dist/LyricStream.Frontend.Public/server/server.mjs",
    "reinstall": "npm run clean && npm install",
    "clean": "rimraf node_modules .angular package-lock.json",
    "restart": "clear && npm run clean && npm install && npm run start",
    "cleanall": "sudo rimraf .angular node_modules package-lock.json && npm cache clean --force && npm run reinstall"
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "dependencies": {
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-server": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@angular/ssr": "^21.2.12",
    "@lyricstream/shared": "file:../LyricStream.Frontend.Shared/dist/shared",
    "@microsoft/signalr": "^10.0.11",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "express": "^5.1.0",
    "ngx-extended-pdf-viewer": "^28.0.0",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.3",
    "ts-cacheable": "^1.0.19",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.12",
    "@angular/cli": "^21.2.12",
    "@angular/compiler-cli": "^21.2.0",
    "@types/express": "^5.0.1",
    "@types/node": "^20.17.19",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
